export default "__VITE_ASSET__sjFQgPtr__"